import { css } from '@emotion/react';

import { isMobile } from './isMobile';

export const borderRadiusFix = () =>
	isMobile
		? css`
				border-radius: 0;
		  `
		: undefined;
